import { Helmet } from 'react-helmet-async';
import React from 'react';
import ProjectInitiativesContainer from '../../containers/projects/ProjectInitiativesContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const ProjectInitiatives = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('project')} | ChangeSync</title>
    </Helmet>
    <ProjectInitiativesContainer slug={slug} projectId={projectId} />
  </>
);

ProjectInitiatives.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(ProjectInitiatives));
